(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9123],{

/***/ 27008:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[productSlug]",
      function () {
        return __webpack_require__(29596);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LeftArrowIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94614);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);





function LeftArrowIcon(_param) {
    var width = _param.width, height = _param.height, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "width",
        "height"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 33 23",
        width: width,
        height: height
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("path", {
            d: "M10.273 1.009a1.112 1.112 0 0 1 1.587 0 1.12 1.12 0 0 1 0 1.571l-8.047 8.047h26.554c.619 0 1.127.492 1.127 1.111s-.508 1.127-1.127 1.127H3.813l8.047 8.032c.429.444.429 1.159 0 1.587a1.112 1.112 0 0 1-1.587 0L.321 12.532a1.12 1.12 0 0 1 0-1.571l9.952-9.952z",
            fill: "currentColor",
            fillRule: "nonzero"
        })
    }));
};


/***/ }),

/***/ 20948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ userHasSearchAccess; }
/* harmony export */ });
function userHasSearchAccess(user) {
    if (!user) {
        return false;
    }
    if (user.__typename === "PendingUser" && user.verified) {
        return true;
    }
    if (user.__typename === "GovernmentUser") {
        return true;
    }
    return user.__typename === "VendorUser" && user.company && user.company.plan && user.company.plan.limits && user.company.plan.limits.searchAccess;
};


/***/ }),

/***/ 35162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T5": function() { return /* binding */ EditProductFormPageSeo; },
/* harmony export */   "ZP": function() { return /* binding */ ProductPageSeo; },
/* harmony export */   "lI": function() { return /* binding */ NewProductFormPageSeo; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84217);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69057);
/* harmony import */ var _components_seo_SeoHead__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35692);





function ProductPageSeo(param) {
    var product = param.product;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var image = product.logo || "https://cdn.filestackcontent.com/Ui1ayHJrQm6JZGwDARxx";
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_components_seo_SeoHead__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: intl.formatMessage({
                    defaultMessage: "{productName} – Govlaunch GovTech Products",
                    id: "TGR2nb"
                }, {
                    productName: product.name
                }),
                description: intl.formatMessage({
                    defaultMessage: "Discover {productName} and other government technology solutions on Govlaunch.",
                    id: "B6VjYj"
                }, {
                    productName: product.name
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("meta", {
                        name: "twitter:image",
                        content: image
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("meta", {
                        property: "og:image",
                        content: image
                    })
                ]
            })
        ]
    });
};
function NewProductFormPageSeo() {
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var message = intl.formatMessage({
        defaultMessage: "Govlaunch - New GovTech Product",
        id: "Twq1TR"
    });
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_components_seo_SeoHead__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        title: message,
        description: message
    });
}
function EditProductFormPageSeo(param) {
    var productName = param.productName;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var message = intl.formatMessage({
        defaultMessage: "{productName} – Edit Govlaunch GovTech Product",
        id: "hIehP/"
    }, {
        productName: productName
    });
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_components_seo_SeoHead__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        title: message,
        description: message
    });
}


/***/ }),

/***/ 87386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useShowMoreCounter; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56262);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63402);


function useShowMoreCounter(total, limit) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,react_use__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(1), 2), count = ref[0], ref1 = ref[1], increment = ref1.inc, decrement = ref1.dec;
    var offset = Math.min(count * limit, total);
    return {
        offset: offset,
        hasMore: count * limit < total,
        hasLess: count > 1,
        showMore: function() {
            return increment(1);
        },
        showLess: function() {
            return decrement(1);
        }
    };
};


/***/ }),

/***/ 47116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22051);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_route_ServerResponseContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14101);




var Redirect = function(param) {
    var to = param.to;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_lib_route_ServerResponseContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Consumer */ .Z.Consumer, {
        children: function(response) {
            if (response) {
                response.writeHead(303, {
                    Location: to
                });
                response.end();
                return null;
            }
            if (true) {
                next_router__WEBPACK_IMPORTED_MODULE_1___default().replace(to);
            }
            return null;
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Redirect);


/***/ }),

/***/ 29596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ProductPage; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18316);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(56262);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(49550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(81871);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+product@2.25.34_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/product/index.ts + 23 modules
var _govlaunch_product = __webpack_require__(74047);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+story@2.26.38_vwg5avgammb3tgf4ng7alozbti_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/story/index.ts + 24 modules
var story = __webpack_require__(7909);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/index.ts + 112 modules
var web = __webpack_require__(19026);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/link.js
var next_link = __webpack_require__(54892);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/router.js
var next_router = __webpack_require__(22051);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(69057);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(90489);
// EXTERNAL MODULE: ./components/auth/Auth.tsx + 1 modules
var Auth = __webpack_require__(27068);
// EXTERNAL MODULE: ./components/makers/userHasSearchAccess.ts
var userHasSearchAccess = __webpack_require__(20948);
// EXTERNAL MODULE: ./components/seo/ProductPageSeo.tsx
var ProductPageSeo = __webpack_require__(35162);
// EXTERNAL MODULE: ./components/vendor/profile/UpgradeToMakersProBanner.tsx
var UpgradeToMakersProBanner = __webpack_require__(589);
// EXTERNAL MODULE: ./intl/locales.ts
var locales = __webpack_require__(30629);
// EXTERNAL MODULE: ./lib/apollo/RefetchQueriesFixLink.ts
var RefetchQueriesFixLink = __webpack_require__(69086);
// EXTERNAL MODULE: ./lib/hooks/useIsMobile.ts
var useIsMobile = __webpack_require__(67459);
// EXTERNAL MODULE: ./lib/mutations/ToggleBookmarkMutation.ts
var ToggleBookmarkMutation = __webpack_require__(19805);
// EXTERNAL MODULE: ./lib/route/Redirect.tsx
var Redirect = __webpack_require__(47116);
// EXTERNAL MODULE: ./lib/withIntl.tsx + 9 modules
var withIntl = __webpack_require__(21505);
// EXTERNAL MODULE: ./types/types.ts
var types = __webpack_require__(43845);
// EXTERNAL MODULE: ./src/utils/nextLinkHref.ts
var nextLinkHref = __webpack_require__(88196);
// EXTERNAL MODULE: ./src/utils/stringOrFirst.ts
var stringOrFirst = __webpack_require__(39327);
// EXTERNAL MODULE: ./src/components/navbar/NavbarLayout.tsx + 62 modules
var NavbarLayout = __webpack_require__(71858);
// EXTERNAL MODULE: ./src/components/translation/TranslateTo.tsx
var TranslateTo = __webpack_require__(77766);
;// CONCATENATED MODULE: ./src/components/product/acl/canSeeGovernmentsUsing.ts
function canSeeGovernmentsUsing(product, viewer) {
    var ref;
    if (!viewer) {
        return false;
    }
    if (!product.company || product.company.plan.name === "Basic") {
        return false;
    }
    if (viewer.__typename === "GovernmentUser") {
        return true;
    }
    if (viewer.__typename === "VendorUser" && ((ref = viewer.company) === null || ref === void 0 ? void 0 : ref._id) === product.company._id) {
        return true;
    }
    return false;
};

;// CONCATENATED MODULE: ./src/components/product/getProductViewMode.ts
function getProductViewMode(_, product, preview, viewerIsMember) {
    if (preview && viewerIsMember) {
        return preview;
    }
    if (product.enrichedProfile) {
        return "makers";
    }
    return "basic";
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(17440);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.5.0/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(18125);
;// CONCATENATED MODULE: ./src/components/product/graphql/IsProductTranslationEnabledQuery.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query IsProductTranslationEnabled($slug: String!) {\n    isTranslationEnabled(slug: $slug)\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var IsProductTranslationEnabledQuery = ((0,lib/* gql */.Ps)(_templateObject()));

// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+project@2.37.38_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/project/index.ts + 59 modules
var project = __webpack_require__(78062);
;// CONCATENATED MODULE: ./src/components/product/graphql/ProductBySlugQuery.ts

function ProductBySlugQuery_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ProductBySlug($slug: String!, $language: String) {\n    product(slug: $slug, language: $language) {\n      ...ProductFields\n      company {\n        viewerIsMember\n      }\n      stories {\n        ...RelatedStoriesFields\n      }\n      projects {\n        ...ProjectCardFields\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ProductBySlugQuery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




/* harmony default export */ var ProductBySlugQuery = ((0,lib/* gql */.Ps)(ProductBySlugQuery_templateObject(), _govlaunch_product/* ProductFieldsFragment */.en, story/* RelatedStoriesFieldsFragment */.M, project/* ProjectCardFieldsFragment */.SS));

// EXTERNAL MODULE: ./src/components/product/graphql/ToggleProductStackMutation.ts
var ToggleProductStackMutation = __webpack_require__(91369);
;// CONCATENATED MODULE: ./src/components/product/icons/ProductSymbolIcon.tsx





function ProductSymbolIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* SvgBox */.$C, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "40px",
        height: "40px",
        viewBox: "0 0 40 40",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                cx: 20,
                cy: 20,
                r: 18.75,
                fill: "#fff",
                stroke: "#3F4A5A",
                strokeWidth: 2.5
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M19.974 8.345l10.029 5.757-10.095 5.852-10.027-5.756 10.093-5.853z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M19.909 20.607a.649.649 0 01-.323-.086L9.56 14.764a.652.652 0 01-.003-1.131L19.65 7.78a.647.647 0 01.647-.002l10.028 5.757a.653.653 0 01.003 1.132L20.234 20.52a.65.65 0 01-.325.087zm-8.724-6.412l8.722 5.007 8.792-5.097-8.723-5.007-8.79 5.097z",
                fill: "#3F4A5A"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M20.025 32.308a.652.652 0 01-.65-.646l-.116-11.701a.654.654 0 01.324-.572l10.095-5.852a.646.646 0 01.646-.002c.201.115.326.328.328.56l.117 11.699a.653.653 0 01-.325.571L20.35 32.22a.65.65 0 01-.324.088zm.537-11.979l.101 10.202 8.803-5.105-.102-10.2-8.802 5.103z",
                fill: "#3F4A5A"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M19.908 19.954l.117 11.701-10.03-5.757-.114-11.7 10.027 5.756z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M20.031 32.308h-.006a.647.647 0 01-.323-.087L9.673 26.464a.654.654 0 01-.327-.56l-.115-11.7a.652.652 0 01.32-.57c.201-.117.45-.119.652-.003l10.028 5.757c.2.115.325.328.327.56l.116 11.608a.651.651 0 01-.642.752zm-9.39-6.79l8.723 5.006-.102-10.189-8.72-5.006.1 10.188z",
                fill: "#3F4A5A"
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(94614);
// EXTERNAL MODULE: ./lib/hooks/useShowMoreCounter.ts
var useShowMoreCounter = __webpack_require__(87386);
// EXTERNAL MODULE: ./src/components/project/listing/ProjectsListing.tsx
var ProjectsListing = __webpack_require__(93921);
;// CONCATENATED MODULE: ./src/components/product/ProductProjects.tsx










function ProductProjects(_param) {
    var product = _param.product, props = (0,_object_without_properties/* default */.Z)(_param, [
        "product"
    ]);
    var router = (0,next_router.useRouter)();
    var ref = (0,useShowMoreCounter/* default */.Z)(product.projects.length || 0, 2), offset = ref.offset, hasMore = ref.hasMore, showMore = ref.showMore;
    var items = product.projects.slice(0, offset) || [];
    if (items.length === 0) {
        return null;
    }
    var onModalClose = function() {
        router.push("/products/".concat(product.slug));
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        bg: "white",
        borderRadius: "md",
        border: "1px",
        borderColor: "gray.100"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                borderBottom: "1px",
                borderColor: "gray.100",
                py: 3,
                px: 8,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Heading */.E2, {
                    as: "h3",
                    color: "gray.900",
                    fontWeight: "bold",
                    fontSize: "lg",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Projects",
                        id: "UxTJRa"
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                py: 3,
                px: [
                    4,
                    4,
                    4,
                    4
                ],
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectsListing/* default */.Z, {
                        projects: items,
                        onModalClose: onModalClose,
                        gridProps: {
                            columns: [
                                1,
                                1,
                                1,
                                2
                            ],
                            gridRowGap: 4
                        }
                    }),
                    hasMore && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Flex */.kC, {
                        justify: "center",
                        mt: 4,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, {
                            variant: "secondary",
                            size: "sm",
                            onClick: showMore,
                            rightIcon: function(props) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    width: "24",
                                    height: "12",
                                    viewBox: "0 0 24 12",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg"
                                }, props), {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M2 2.5L11.7436 9.55882L22 2.5",
                                        stroke: "currentColor",
                                        strokeWidth: "3",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                }));
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Show more",
                                id: "aWpBzj"
                            })
                        })
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+palette@0.4.0/node_modules/@govlaunch/palette/index.js
var palette = __webpack_require__(95576);
// EXTERNAL MODULE: ./components/icons/LeftArrowIcon.tsx
var LeftArrowIcon = __webpack_require__(9128);
;// CONCATENATED MODULE: ./src/components/product/TopLevelPreviewProductNavbar.tsx







function TopLevelPreviewProductNavbar(param) {
    var productSlug = param.productSlug, preview = param.preview, isEnrichedProfile = param.isEnrichedProfile;
    if (!preview) {
        return null;
    }
    var viewingAsBasic = preview === "basic";
    var basicSwitchProps = {
        padding: 4,
        ":hover": {
            opacity: 0.8
        }
    };
    var makersSwitchProps = {
        padding: 4,
        ":hover": {
            opacity: 0.8
        }
    };
    var notSelectedProps = {
        color: palette/* darkGray */.O5
    };
    var selectedProps = {
        backgroundImage: "linear-gradient(97deg, #086BE5 10%, #28D094 60%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        fontWeight: "bold"
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            display: "flex",
            width: "100%",
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                href: "/products/[productSlug]/edit",
                as: "/products/".concat(productSlug, "/edit"),
                passHref: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                    css: {
                        color: palette/* darkGray */.O5,
                        display: "flex",
                        alignItems: "center",
                        ":hover": {
                            opacity: 0.7
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LeftArrowIcon/* default */.Z, {
                            width: 20,
                            height: 10
                        }),
                        " ",
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            css: {
                                marginLeft: 4
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Leave Preview",
                                id: "qJ60r9"
                            })
                        })
                    ]
                })
            }),
            !isEnrichedProfile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    marginLeft: 12,
                    background: "-webkit-linear-gradient(97deg, #086BE5 10%, #28D094 60%);",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    ":hover": {
                        opacity: 0.8
                    }
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                    href: "/makers",
                    passHref: true,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Upgrade to Makers",
                            id: "FzYfeI"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "auto"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        href: "/products/".concat(productSlug, "?preview=basic"),
                        passHref: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                            css: viewingAsBasic ? (0,_object_spread/* default */.Z)({}, basicSwitchProps, selectedProps) : (0,_object_spread/* default */.Z)({}, basicSwitchProps, notSelectedProps),
                            children: viewingAsBasic ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Viewing as Basic",
                                id: "IDIB6H"
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "View as Basic",
                                id: "R4FHJW"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        href: "/products/".concat(productSlug, "?preview=makers"),
                        passHref: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                            css: viewingAsBasic ? (0,_object_spread/* default */.Z)({}, makersSwitchProps, notSelectedProps) : (0,_object_spread/* default */.Z)({}, makersSwitchProps, selectedProps),
                            children: viewingAsBasic ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "View as Makers",
                                id: "yy+KTi"
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Viewing as Makers",
                                id: "SagT9D"
                            })
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/product/pages/ProductBySlugPage.tsx



































function ProductBySlugPage() {
    var viewer = (0,Auth/* useSelfie */.yD)();
    var router = (0,next_router.useRouter)();
    var isMobile = (0,useIsMobile/* default */.Z)();
    var intl = (0,useIntl/* default */.Z)();
    var locale = (0,withIntl/* useIntlLocale */.U)().locale;
    var productSlug = (0,stringOrFirst/* default */.Z)(router.query.productSlug);
    var ref = (0,useQuery/* useQuery */.a)(IsProductTranslationEnabledQuery, {
        variables: {
            slug: productSlug
        },
        fetchPolicy: "network-only"
    }), translationCheckData = ref.data;
    var lang = (0,stringOrFirst/* default */.Z)(router.query.lang);
    var langExists = typeof lang !== "undefined" && lang.length > 0 && lang !== "en-US";
    var targetLanguage = lang || locale;
    var showTranslateButton = typeof translationCheckData !== "undefined" && translationCheckData.isTranslationEnabled !== null && translationCheckData.isTranslationEnabled && (langExists || locale !== "en-US");
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ToggleBookmarkMutation/* default */.Z), 1), toggleBookmark = ref1[0];
    var ref2 = (0,useQuery/* useQuery */.a)(ProductBySlugQuery, {
        variables: {
            slug: productSlug,
            language: (0,locales/* findLanguageByLocale */.Y)(lang)
        },
        fetchPolicy: "network-only"
    }), loading = ref2.loading, data = ref2.data, refetch = ref2.refetch;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ToggleProductStackMutation/* default */.Z), 1), toggleProductStack = ref3[0];
    if (loading) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavbarLayout/* default */.Z, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* PageGridContainer */.pf, {
                justifyContent: "center",
                py: 6,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* LoadingSpinner */.TK, {})
            })
        });
    }
    var product = data === null || data === void 0 ? void 0 : data.product;
    if (!product) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Redirect/* default */.Z, {
            to: "/"
        });
    }
    var viewAs = getProductViewMode(viewer, product, router.query.preview, product.company && product.company.viewerIsMember);
    var searchAccess = (0,userHasSearchAccess/* default */.Z)(viewer) || product.company && product.company.viewerIsMember;
    var isPreviewing = [
        "makers",
        "basic"
    ].includes((0,stringOrFirst/* default */.Z)(router.query.preview));
    if (viewer && viewer.__typename === "VendorUser" && !searchAccess) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavbarLayout/* default */.Z, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* PageContainer */._z, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UpgradeToMakersProBanner/* default */.Z, {})
            })
        });
    }
    var renderProductLink = function(product, children) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
            href: "/products/".concat(product.slug),
            scroll: false,
            children: children
        }, product.slug);
    };
    var productSharing = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_product/* ProductSharing */.F5, {
        product: product,
        onToggleBookmark: function() {
            toggleBookmark({
                refetchQueries: (0,RefetchQueriesFixLink/* refetchQueries */.h)([
                    "Government"
                ]),
                variables: {
                    targetType: types/* IBookmarkType.Product */.Cw.Product,
                    targetId: product._id
                }
            });
        }
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NavbarLayout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductPageSeo/* default */.ZP, {
                product: product
            }),
            product.company && product.company.viewerIsMember && isPreviewing && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* PageContainer */._z, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopLevelPreviewProductNavbar, {
                    productSlug: product.slug,
                    preview: viewAs,
                    isEnrichedProfile: product.company.plan.name !== "Basic"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* PageGridContainer */.pf, {
                gridTemplateColumns: "max-content max-content",
                alignItems: "center",
                justifyContent: "space-between",
                gridColumnGap: 6,
                mt: 6,
                children: [
                    isMobile && false && /*#__PURE__*/ 0,
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Grid */.rj, {
                        gridTemplateColumns: "40px max-content",
                        alignItems: "center",
                        gridColumnGap: 2,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductSymbolIcon, {}),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                    href: product.company ? "/vendors/[vendorSlug]" : "/products",
                                    as: product.company ? "/vendors/".concat(product.company.slug) : "/products",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                        color: "grey.600",
                                        textTransform: "uppercase",
                                        children: product.company && !isMobile ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "All {companyName} Products",
                                            id: "gyhajX",
                                            values: {
                                                companyName: product.company.name
                                            }
                                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "All Products",
                                            id: "enAu2b"
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                my: 4,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* PageGridContainer */.pf, {
                    gridTemplateColumns: [
                        "1fr",
                        "1fr",
                        "3fr 1fr"
                    ],
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TranslateTo/* default */.Z, {
                        langExists: langExists,
                        showTranslateButton: showTranslateButton,
                        refetch: function() {
                            if (refetch) {
                                refetch({
                                    slug: productSlug,
                                    language: (0,locales/* findLanguageByLocale */.Y)(targetLanguage)
                                });
                            }
                        },
                        refetchOriginal: function() {
                            if (refetch) {
                                refetch({
                                    slug: productSlug,
                                    language: null
                                });
                            }
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                my: 4,
                pb: 6,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* PageGridContainer */.pf, {
                    gridTemplateColumns: [
                        "1fr",
                        "1fr",
                        "3fr 1fr"
                    ],
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_product/* ProductHeader */.cN, {
                                    product: product,
                                    translationButton: function() {
                                        if (isMobile) {
                                            return null;
                                        }
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TranslateTo/* default */.Z, {
                                            langExists: langExists,
                                            showTranslateButton: showTranslateButton,
                                            refetch: function() {
                                                if (refetch) {
                                                    refetch({
                                                        slug: productSlug,
                                                        language: (0,locales/* findLanguageByLocale */.Y)(targetLanguage)
                                                    });
                                                }
                                            },
                                            refetchOriginal: function() {
                                                if (refetch) {
                                                    refetch({
                                                        slug: productSlug,
                                                        language: null
                                                    });
                                                }
                                            }
                                        });
                                    },
                                    isMobile: isMobile,
                                    renderTagLinkWrap: function(tag, children) {
                                        var linkHref = (0,nextLinkHref/* default */.Z)("/collections/[collectionSlug]/[[...tab]]", {
                                            collectionSlug: tag.slug
                                        });
                                        var linkAs = "/collections/".concat(tag.slug, "/products");
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                            href: linkHref,
                                            as: linkAs,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                                href: linkAs,
                                                children: children
                                            })
                                        }, linkAs);
                                    }
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                                    bg: "white",
                                    borderRadius: "md",
                                    border: "1px",
                                    borderColor: "gray.100",
                                    p: 4,
                                    mt: 5,
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_product/* ProductGallery */.Li, {
                                            product: product,
                                            mt: 3
                                        }),
                                        product.about && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                                    height: "1px",
                                                    bg: "gray.100",
                                                    mt: 8,
                                                    mb: 8
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                                    fontSize: "sm",
                                                    children: product.about
                                                })
                                            ]
                                        }),
                                        !isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Flex */.kC, {
                                            mt: 6,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                                marginLeft: "auto",
                                                children: productSharing
                                            })
                                        })
                                    ]
                                }),
                                viewAs === "makers" && product.highlights.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Highlights */.xK, {
                                    highlights: product.highlights,
                                    mt: 6
                                }),
                                viewAs === "makers" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_product/* ProductNewsworthy */.nu, {
                                    stacked: isMobile,
                                    product: product,
                                    mt: 5
                                }),
                                viewAs === "makers" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductProjects, {
                                    product: product,
                                    mt: 5
                                }),
                                canSeeGovernmentsUsing(product, viewer) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_product/* ProductGovernments */.mW, {
                                    product: product,
                                    mt: 5,
                                    renderLinkWrap: function(government, children) {
                                        var linkHref = (0,nextLinkHref/* default */.Z)("/government", {
                                            governmentSlug: government.slug
                                        });
                                        var linkAs = "/governments/".concat(government.slug);
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                            as: linkAs,
                                            href: linkHref,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                                href: linkAs,
                                                children: children
                                            })
                                        }, government.slug);
                                    }
                                })
                            ]
                        }),
                        isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                            maxWidth: 300,
                            mx: "auto",
                            children: productSharing
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                            mt: 3,
                            children: [
                                (viewer === null || viewer === void 0 ? void 0 : viewer.__typename) === "GovernmentUser" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, {
                                    mb: 2,
                                    variantColor: product.inViewerStack ? "red" : "teal",
                                    variant: "solid",
                                    fullWidth: true,
                                    leftIcon: function(props) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            width: 25,
                                            height: 25,
                                            viewBox: "0 0 25 25",
                                            fill: "none"
                                        }, props), {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("mask", {
                                                    id: "salkj4lkz",
                                                    fill: "#fff",
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                                        x: 0.648,
                                                        y: 6.527,
                                                        width: 24,
                                                        height: 17.143,
                                                        rx: 1
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                                                    x: 0.648,
                                                    y: 6.527,
                                                    width: 24,
                                                    height: 17.143,
                                                    rx: 1,
                                                    stroke: "#fff",
                                                    strokeWidth: 3.4,
                                                    mask: "url(#salkj4lkz)"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                                    stroke: "#fff",
                                                    strokeLinecap: "round",
                                                    d: "M4.576 4.313h16.143M8.005.885h9.285"
                                                })
                                            ]
                                        }));
                                    },
                                    onClick: function() {
                                        if (viewer && viewer.__typename === "GovernmentUser") {
                                            toggleProductStack({
                                                variables: {
                                                    productId: product._id,
                                                    governmentId: viewer.government._id
                                                }
                                            });
                                        }
                                    },
                                    children: product.inViewerStack ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Remove from Stack",
                                        id: "fMgmCu"
                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Add to Stack",
                                        id: "7rcJw5"
                                    })
                                }),
                                !isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                    children: [
                                        product.link && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* AnchorButton */.AN, {
                                            href: product.link,
                                            external: "outside-govlaunch",
                                            my: 2,
                                            variant: "outline",
                                            variantColor: "teal",
                                            fullWidth: true,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "Visit website",
                                                id: "YXprDM"
                                            })
                                        }),
                                        viewAs === "makers" && product.contactPage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* AnchorButton */.AN, {
                                            href: product.contactPage,
                                            external: "outside-govlaunch",
                                            my: 2,
                                            variant: "outline",
                                            variantColor: "teal",
                                            fullWidth: true,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "Contact",
                                                id: "zFegDD"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_product/* ProductVendorCard */.wN, {
                                    product: product,
                                    mt: 4,
                                    renderLinkWrap: function(company, children) {
                                        var linkHref = (0,nextLinkHref/* default */.Z)("/vendor", {
                                            vendorSlug: company.slug
                                        });
                                        var linkAs = "/vendors/".concat(company.slug);
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                            href: linkHref,
                                            as: linkAs,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                                href: linkAs,
                                                children: children
                                            })
                                        });
                                    }
                                }),
                                isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                    children: [
                                        product.link && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* AnchorButton */.AN, {
                                            href: product.link,
                                            external: "outside-govlaunch",
                                            my: 2,
                                            variant: "outline",
                                            variantColor: "teal",
                                            fullWidth: true,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "Visit website",
                                                id: "YXprDM"
                                            })
                                        }),
                                        viewAs === "makers" && product.contactPage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* AnchorButton */.AN, {
                                            href: product.contactPage,
                                            external: "outside-govlaunch",
                                            my: 2,
                                            variant: "outline",
                                            variantColor: "teal",
                                            fullWidth: true,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "Contact",
                                                id: "zFegDD"
                                            })
                                        })
                                    ]
                                }),
                                viewAs === "makers" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_product/* ProductSiblingsCard */.XF, {
                                    product: product,
                                    renderLinkWrap: renderProductLink
                                }),
                                viewAs === "makers" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_product/* ProductDetailsCard */.o, {
                                    product: product
                                }),
                                viewAs === "makers" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_product/* ProductIntegrationsCard */.dw, {
                                    product: product,
                                    renderLinkWrap: renderProductLink
                                }),
                                viewAs === "makers" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_product/* ProductSolutionsCard */.JY, {
                                    product: product
                                }),
                                viewAs === "makers" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_product/* ProductDeploymentCard */.zi, {
                                    product: product
                                }),
                                viewAs === "makers" && product.resources && product.resources.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                    mt: 4,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* ResourcesBox */.K0, {
                                        children: product.resources.map(function(resource) {
                                            if (resource.__typename === "LinkResource" && resource.url) {
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* LinkResource */.iI, {
                                                    href: resource.url,
                                                    children: resource.title
                                                }, resource.url);
                                            }
                                            if (resource.__typename === "DownloadResource" && resource.url) {
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* DownloadResource */.Jo, {
                                                    href: resource.url,
                                                    children: resource.title
                                                }, resource.url);
                                            }
                                            return null;
                                        }).filter(Boolean)
                                    })
                                }),
                                viewAs === "basic" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_product/* ProductAlternativesCard */.ad, {
                                    product: product,
                                    renderLinkWrap: renderProductLink
                                }),
                                viewAs === "makers" && product.stories !== null && product.stories.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(story/* StoryRelatedStories */.fp, {
                                    title: intl.formatMessage({
                                        defaultMessage: "Stories ({numberOfStories})",
                                        id: "llfnTe"
                                    }, {
                                        numberOfStories: product.stories.length
                                    }),
                                    relatedStories: product.stories || [],
                                    placeholderImageSrc: "/static/story/story-card-placeholder.png",
                                    mt: 4,
                                    renderLinkWrap: function(story, children) {
                                        var linkHref = (0,nextLinkHref/* default */.Z)("/stories/[storySlug]", {
                                            storySlug: story.slug
                                        });
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                            href: linkHref,
                                            as: "/stories/".concat(story.slug),
                                            scroll: false,
                                            children: children
                                        }, story.slug);
                                    }
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/products/[productSlug].tsx



function ProductPage() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductBySlugPage, {});
};


/***/ }),

/***/ 91369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18125);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation ToggleProductStack($governmentId: ObjectId, $productId: ObjectId) {\n    toggleProductStack(governmentId: $governmentId, productId: $productId) {\n      _id\n      inViewerStack\n      governmentsUsingCount\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject()));


/***/ }),

/***/ 70455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProjectCards; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_project__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78062);
/* harmony import */ var _govlaunch_web__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19026);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54892);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22051);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59496);
/* harmony import */ var _components_project_EmptyProjectSlot__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33563);
/* harmony import */ var _src_utils_nextLinkHref__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88196);
/* harmony import */ var _src_utils_stringOrFirst__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(39327);
/* harmony import */ var _src_components_project_CreateProjectModal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23115);
/* harmony import */ var _src_components_project_modal_ProjectModal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96077);
/* harmony import */ var _src_components_project_listing_computeNavigationProps__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(36668);
/* harmony import */ var lodash_fp_noop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98483);
/* harmony import */ var lodash_fp_noop__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_noop__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _lib_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67459);
/* harmony import */ var _lib_withIntl__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(21505);
/* harmony import */ var _src_components_translation_TranslationButton__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(98769);


















function ProjectCards(param) {
    var projects = param.projects, gridProps = param.gridProps, _onClick = param.onClick, onClick = _onClick === void 0 ? (lodash_fp_noop__WEBPACK_IMPORTED_MODULE_9___default()) : _onClick, _withAddProjectSlot = param.withAddProjectSlot, withAddProjectSlot = _withAddProjectSlot === void 0 ? false : _withAddProjectSlot, addProjectSlotText = param.addProjectSlotText, firstLocationId = param.firstLocationId, firstLocationCountry = param.firstLocationCountry, groupId = param.groupId, projectNavigationLimit = param.projectNavigationLimit, onModalClose = param.onModalClose, _routeParams = param.routeParams, routeParams = _routeParams === void 0 ? {} : _routeParams;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var isMobile = (0,_lib_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), showCreateProjectModal = ref[0], setShowCreateProjectModal = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null), relatedProject = ref1[0], setRelatedProject = ref1[1];
    var locale = (0,_lib_withIntl__WEBPACK_IMPORTED_MODULE_11__/* .useIntlLocale */ .U)().locale;
    var projectSlugFromRouter = router.query.projectSlug;
    var langFromRouter = router.query.lang;
    var slugExistsOnProjects = projects.some(function(project) {
        return project.slug === projectSlugFromRouter;
    }) || relatedProject;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_src_components_project_CreateProjectModal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                isOpen: showCreateProjectModal,
                onClose: function() {
                    return setShowCreateProjectModal(false);
                },
                groupId: groupId
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsxs */ .BX)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_1__/* .PageGridContainer */ .pf, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                px: 0
            }, gridProps), {
                children: [
                    withAddProjectSlot && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_components_project_EmptyProjectSlot__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        onClick: function() {
                            return setShowCreateProjectModal(true);
                        },
                        groupId: groupId,
                        text: addProjectSlotText
                    }),
                    projects.map(function(project, index) {
                        var linkHref = isMobile ? "/projects/".concat(project.slug) : (0,_src_utils_nextLinkHref__WEBPACK_IMPORTED_MODULE_6__/* .appendNextLinkHrefParams */ .o)(router, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                            projectSlug: project.slug
                        }, routeParams));
                        var translationLinkHref = isMobile ? "/projects/[projectSlug]" : (0,_src_utils_nextLinkHref__WEBPACK_IMPORTED_MODULE_6__/* .appendNextLinkHrefParams */ .o)(router, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                            projectSlug: project.slug,
                            lang: locale
                        }, routeParams));
                        var translationLinkWrap = function() {
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_src_components_translation_TranslationButton__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                paddingY: "4px",
                                onClick: function(event) {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    router.push(translationLinkHref, "/projects/".concat(project.slug, "?lang=").concat(locale));
                                }
                            });
                        };
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: linkHref,
                            as: "/projects/".concat(project.slug),
                            passHref: true,
                            scroll: false,
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_govlaunch_project__WEBPACK_IMPORTED_MODULE_0__/* .ProjectCard */ .t, {
                                "data-intercom-target": index === 0 ? "First project" : undefined,
                                project: project,
                                onClick: function(event) {
                                    return onClick(event, project, index);
                                },
                                firstLocationId: firstLocationId,
                                firstLocationCountry: firstLocationCountry,
                                translationLinkWrap: locale !== "en-US" ? translationLinkWrap : undefined
                            })
                        }, project._id);
                    })
                ]
            })),
            projectSlugFromRouter && slugExistsOnProjects && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_src_components_project_modal_ProjectModal__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                onClickProject: function(project) {
                    setRelatedProject(project);
                },
                projectSlug: (0,_src_utils_stringOrFirst__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(projectSlugFromRouter),
                navigation: (0,_src_components_project_listing_computeNavigationProps__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(projects.slice(0, projectNavigationLimit), (0,_src_utils_stringOrFirst__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(projectSlugFromRouter)),
                onClose: onModalClose,
                lang: (0,_src_utils_stringOrFirst__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(langFromRouter)
            })
        ]
    });
};


/***/ }),

/***/ 93921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProjectsListing; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_web__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19026);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var _components_form_resources_ShowMoreButtonWithIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38248);
/* harmony import */ var _src_shared_components_NoResultsFound__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57600);
/* harmony import */ var _src_components_project_listing_ProjectCards__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70455);






function ProjectsListing(param) {
    var projects = param.projects, loading = param.loading, onLoadMore = param.onLoadMore, hasNextPage = param.hasNextPage, onModalClose = param.onModalClose, _gridProps = param.gridProps, gridProps = _gridProps === void 0 ? {
        columns: [
            1,
            1,
            2,
            3
        ],
        spacingY: 6
    } : _gridProps, _withAddProjectSlot = param.withAddProjectSlot, withAddProjectSlot = _withAddProjectSlot === void 0 ? false : _withAddProjectSlot, addProjectSlotText = param.addProjectSlotText, groupId = param.groupId, onClickProject = param.onClickProject, _projectNavigationLimit = param.projectNavigationLimit, projectNavigationLimit = _projectNavigationLimit === void 0 ? Infinity : _projectNavigationLimit, firstLocationId = param.firstLocationId, firstLocationCountry = param.firstLocationCountry;
    if (!loading && projects.length === 0) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .PageContainer */ ._z, {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_src_shared_components_NoResultsFound__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                mt: 32
            })
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_src_components_project_listing_ProjectCards__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                projects: projects,
                gridProps: gridProps,
                withAddProjectSlot: withAddProjectSlot,
                addProjectSlotText: addProjectSlotText,
                groupId: groupId,
                onClick: onClickProject,
                firstLocationId: firstLocationId,
                firstLocationCountry: firstLocationCountry,
                projectNavigationLimit: projectNavigationLimit,
                onModalClose: onModalClose
            }),
            hasNextPage && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Flex */ .kC, {
                justifyContent: "center",
                mt: 6,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_components_form_resources_ShowMoreButtonWithIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    loading: loading || false,
                    onClick: function() {
                        if (typeof onLoadMore !== "undefined") {
                            onLoadMore();
                        }
                    }
                })
            })
        ]
    });
};


/***/ }),

/***/ 63402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useCounter; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-use@17.4.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-use/esm/useUpdate.js

var updateReducer = function (num) { return (num + 1) % 1000000; };
function useUpdate() {
    var _a = (0,react.useReducer)(updateReducer, 0), update = _a[1];
    return update;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/react-use@17.4.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-use/esm/misc/hookState.js
function resolveHookState(nextState, currentState) {
    if (typeof nextState === 'function') {
        return nextState.length ? nextState(currentState) : nextState();
    }
    return nextState;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/react-use@17.4.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-use/esm/useGetSet.js



function useGetSet(initialState) {
    var state = (0,react.useRef)(resolveHookState(initialState));
    var update = useUpdate();
    return (0,react.useMemo)(function () { return [
        function () { return state.current; },
        function (newState) {
            state.current = resolveHookState(newState, state.current);
            update();
        },
    ]; }, []);
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/react-use@17.4.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-use/esm/useCounter.js



function useCounter(initialValue, max, min) {
    if (initialValue === void 0) { initialValue = 0; }
    if (max === void 0) { max = null; }
    if (min === void 0) { min = null; }
    var init = resolveHookState(initialValue);
    typeof init !== 'number' &&
        console.error('initialValue has to be a number, got ' + typeof initialValue);
    if (typeof min === 'number') {
        init = Math.max(init, min);
    }
    else if (min !== null) {
        console.error('min has to be a number, got ' + typeof min);
    }
    if (typeof max === 'number') {
        init = Math.min(init, max);
    }
    else if (max !== null) {
        console.error('max has to be a number, got ' + typeof max);
    }
    var _a = useGetSet(init), get = _a[0], setInternal = _a[1];
    return [
        get(),
        (0,react.useMemo)(function () {
            var set = function (newState) {
                var prevState = get();
                var rState = resolveHookState(newState, prevState);
                if (prevState !== rState) {
                    if (typeof min === 'number') {
                        rState = Math.max(rState, min);
                    }
                    if (typeof max === 'number') {
                        rState = Math.min(rState, max);
                    }
                    prevState !== rState && setInternal(rState);
                }
            };
            return {
                get: get,
                set: set,
                inc: function (delta) {
                    if (delta === void 0) { delta = 1; }
                    var rDelta = resolveHookState(delta, get());
                    if (typeof rDelta !== 'number') {
                        console.error('delta has to be a number or function returning a number, got ' + typeof rDelta);
                    }
                    set(function (num) { return num + rDelta; });
                },
                dec: function (delta) {
                    if (delta === void 0) { delta = 1; }
                    var rDelta = resolveHookState(delta, get());
                    if (typeof rDelta !== 'number') {
                        console.error('delta has to be a number or function returning a number, got ' + typeof rDelta);
                    }
                    set(function (num) { return num - rDelta; });
                },
                reset: function (value) {
                    if (value === void 0) { value = init; }
                    var rValue = resolveHookState(value, get());
                    if (typeof rValue !== 'number') {
                        console.error('value has to be a number or function returning a number, got ' + typeof rValue);
                    }
                    // eslint-disable-next-line react-hooks/exhaustive-deps
                    init = rValue;
                    set(rValue);
                },
            };
        }, [init, min, max]),
    ];
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3481,5522,2727,7909,4047,9932,504,5017,2670,9774,2888,179], function() { return __webpack_exec__(27008); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);